import React from 'react';
import { colors } from '../config';

const FormError = ({ children, ...rest }) => (
  <div {...rest}>
    {children}

    <style jsx>{`
      div {
        animation: fadeIn 0.35s ease;
        color: ${colors.formErrorColor};
        font-size: 12px;
        line-height: 1.35;
        margin-top: 4px;
      }

      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `}</style>
  </div>
);

export default FormError;
